import { TEXT_WIDTH_LIMIT, HOVER_TEXT_WIDTH_LIMIT } from '../../constants';

// Draw text with word wrapping
export function _drawTruncatedText(clusterNode, ctx, globalScale, sizeBy, hoverMap) { // eslint-disable-line
  const { hoverId, clusterIds={}, isClusterListHover, displayFullLabelOnHover } = hoverMap;
  const { label, id, x, y } = clusterNode;
  const isHighlighted = hoverId && clusterIds[id];
  const fillStyleRectOpacity = isHighlighted ? '0.6' : '0.3';
  const fillStyleRect = `rgba(0, 0, 0, ${fillStyleRectOpacity})`;
  const fillStyleText = isHighlighted ? '#20a0fe' : 'rgba(255, 255, 255, 0.8)';
  const isHovered = hoverId && hoverId === id;
  const fontSize = isHovered ? 20 : 16;
  const relativeFontSize = fontSize / globalScale;
  const rectangleHeight = relativeFontSize * 1.4;
  const rectangleHeightHalf = rectangleHeight / 2;
  const rectangleWidthOffset = (10 / globalScale);

  ctx.font = `${relativeFontSize}px Sans-Serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // highlight hovered cluster
  ctx.globalAlpha = hoverId && !clusterIds[id] ? 0.2 : 1;
  // change node size to scale to height of rectangle (for the hover event)
  clusterNode.size = rectangleHeightHalf;

  // Group text into lines
  const textWidthLimit = isHovered ? HOVER_TEXT_WIDTH_LIMIT : TEXT_WIDTH_LIMIT;
  const characters = label.split('');
  let lines = [];
  let charIndex = 0;
  const charactersLength = characters.length;
  while (charIndex < charactersLength) {
    let line = '';
    let lineWidth = 0;
    while (lineWidth < textWidthLimit && charIndex < charactersLength) {
      line += characters[charIndex];
      charIndex++;
      lineWidth = ctx.measureText(line).width;
    }
    lines.push(line);
  }

  const firstLineExceedsWidth = ctx.measureText(lines[0]).width > textWidthLimit;
  // only some clusterTypes should show full label text and only when they are not hovered on from the list
  const shouldTruncateLabel = !isHovered || isClusterListHover || !displayFullLabelOnHover;
  if (firstLineExceedsWidth && shouldTruncateLabel) {
    lines = [lines[0].substring(0, lines[0].length - 3) + '...'];
  }

  lines.forEach((line, index) => {
    const lineWidth = ctx.measureText(line).width;
    const rectangleWidth = lineWidth + rectangleWidthOffset;

    // draw rectangle
    ctx.fillStyle = fillStyleRect;
    ctx.fillRect(
      x - rectangleWidth / 2,
      y - rectangleHeightHalf + (rectangleHeight * index),
      rectangleWidth,
      rectangleHeight
    );
    // draw text after background so text appears on top
    ctx.fillStyle = fillStyleText;
    ctx.fillText(line, x, y + (rectangleHeight * index));
  });
}

export function _drawCircle(authorNode, ctx, globalScale, sizeBy, hoverMap) { // eslint-disable-line
  const { hoverId, nodeType, authorIds={} } = hoverMap;
  const { id, x, y, normalizedSizes, targetClusters, color } = authorNode;
  const isDimmed = hoverId && !(authorIds[id] || (nodeType === 'cluster' && targetClusters[hoverId]));
  const size = normalizedSizes[sizeBy];

  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  ctx.globalAlpha = isDimmed ? 0.2 : 1;
  ctx.fill();
}

export function drawNodeToCanvas(authorNode, ctx, globalScale, sizeBy, hoverMap) { // eslint-disable-line
  if(authorNode.nodeType === 'cluster') {
    _drawTruncatedText(authorNode, ctx, globalScale, sizeBy, hoverMap);
  } else {
    _drawCircle(authorNode, ctx, globalScale, sizeBy, hoverMap);
  }
}

export function getLinkColor(link, hoverMap){
  const { linkType, target: { id: targetId }, source: { id: sourceId }, id } = link;
  const { hoverId, linkIds={} } = hoverMap;
  const highlighted = !hoverId || targetId === hoverId || sourceId === hoverId || linkIds[id];
  let color = 'rgb(255,255,255,0.1)';

  if (highlighted) {
    color = 'rgba(180, 191, 214, 0.5)';
  }

  return color;
}

